export const DropdownProps = (formik: any, name: string) => ({
  value: formik.values[name],
  setValue: formik.setFieldValue,
  setTouched: formik.getFieldHelpers(name).setTouched,
  error:
    formik.submitCount && formik.touched[name]
      ? formik.errors[name]
      : undefined,
})
